import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Zone extends EntityDto implements IEntityDto {
    Zone_Id: string;
    ZoneName: string; 
    Code:string;
    Emp_Ref_Id: string;
    EmployeeName: string;
    Phone: string;
    EmailId: string;
    Company_Id: string;
    CompanyName: string;
    TotalCount: number;
    IsActive: boolean;
    
    constructor() {
        super();
        this.Zone_Id = "00000000-0000-0000-0000-000000000000";
        this.ZoneName = "";
        this.Code="";
        this.EmailId = "";
        this.Phone = "";
        this.Emp_Ref_Id = '';
        this.EmployeeName = '';
        this.Company_Id = "";
        this.CompanyName = ""; 
        this.TotalCount = 0; 
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'ZoneName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' }, 
            { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Phone is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Email is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone Head is required' },    
            //{ FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
        ];
    }
}
